<template>
    <div class="home">

        <!-- <div class="home-content"> -->
        <!-- mk1 -->
        <!-- mk2 -->
        <div class="mk2">
            <!-- 1 -->
            <div>
                <div>
                    <!-- <span class="name">单词搜索</span> -->
                    <el-input v-model="input" placeholder="请输入要搜索的单词"> <el-button slot="append"
                            icon="el-icon-search"></el-button></el-input>
                </div>
            </div>
        </div>
        <!-- 2 -->

        <!-- 3 -->

        <!--  -->
        <div class="tables">
            <div class="mk2title">
                <span>单词列表</span>
                <div class="btns">
                    <div @click="handleAutoAdd">+从百度自动新增</div>
                    <div @click="handleAdd">+手动新增</div>
                </div>
            </div>
            <!-- 单词表格 -->
            <zdzyTableFuhe :tableData="itemList" @dataDouctDetail="dataDouctDetail"
                @handleClickDelete="handleClickDelete" @handleClickEdit="handleClickEdit"></zdzyTableFuhe>
            <!-- 翻页 -->
            <div class="pagination">
                <zdzy-pagination :formData="dataList" @addlistenerData="addlistenerData" ref="child"></zdzy-pagination>
            </div>
        </div>
        <!-- 百度添加单词-->
        <zdzyDialog res="dialogs" :dialogFormVisible="dialogFormVisible" @onclose="onclose" @updateData="updateData"></zdzyDialog>
        <!-- 手动添加单词 -->
        <zdzy-dialog-hand-add res="dialogs" :dialogFormVisible="dialogFormVisibleAdd" :rowdata="rowdata" @onclose="onclose" @editUpdateData="editUpdateData"></zdzy-dialog-hand-add>
        <!-- 编辑单词 -->
        <zdzyDialogEdit res="dialogs" :dialogFormVisible="dialogFormVisibleEdit" :rowdata="rowdata" @onclose="onclose" @editUpdateData="editUpdateData"></zdzyDialogEdit>
    </div>
</template>
<script>
    import zdzyTableFuhe from "@/components/word/zdzy-table-fuhe.vue"
    import zdzyPagination from "@/components/word/zdzy-pagination.vue"
    import zdzyDialog from "@/components/word/zdzy-dialog.vue"
    import zdzyDialogEdit from "@/components/word/zdzy-dialog-edit.vue"
    import zdzyDialogHandAdd from "@/components/word/zdzy-dialog-hand-add.vue"
    import { get, post } from "@/axios/index.js"
    import { wordList, wordCreate, worddelete, deleteWord,addHandWrod } from "@/api/kyword.js"
    export default {
        name: "wordList",
        components: {
            zdzyTableFuhe,
            zdzyPagination,
            zdzyDialog,
            zdzyDialogEdit,
            zdzyDialogHandAdd
        },
        data() {
            return {
                dataList: [],
                itemList: [],
                input: '',
                dialogFormVisible: false,
                dialogFormVisibleEdit:false,
                dialogFormVisibleAdd:false,
                rowdata:{}
            }
        },
        created() {
            this.getwordList();
        },
        methods: {
            getwordList() {
                //console.log(this.baseURL)
                wordList(this.form)
                    .then((res) => {
                        //console.log("拉取数据",res.data.data)
                        this.dataList = res.data.data
                        // this.itemList=this.dataList
                        this.$refs.child.init(this.dataList)

                    })
            },
            //网络增加单词
            handleAutoAdd() {
                this.dialogFormVisible = true
            },
            //手动新增
            handleAdd() {
                // this.dialogFormVisible = true
                this.dialogFormVisibleAdd=true
             },
             //编辑单词
             handleClickEdit(row){
                this.dialogFormVisibleEdit = true
                this.rowdata=row
                //console.log('编辑打开',this.rowdata)
             },
            onclose() {
                this.dialogFormVisible = false
                this.dialogFormVisibleEdit = false
                this.dialogFormVisibleAdd=false
            },
            updateData() {
                setTimeout(() => {
                    this.getwordList()
                }, 2000);
            },
            editUpdateData() {
                setTimeout(() => {
                    this.getwordList()
                }, 2000);
            },
            dataDouctDetail() {
                this.$router.push("fuheDoDetail")
            },
            addlistenerData(datas) {
                this.itemList = datas;
            },
            handleClickDelete(row) {
                //   //console.log(row)
                let id = row.id;
                this.dataList.forEach((item, index) => {
                    if (item.id == id) {
                        this.dataList.splice(index, 1)
                        this.$refs.child.init(this.dataList)
                        this.deleteword(id)
                    }
                })
            },
            //从数据库删除
            deleteword(id) {
                let param = {
                    id: id
                }
                deleteWord(param)
                    .then((res) => {
                        if(res.status==200){
                            this.$message({
                            message: '删除成功',
                            type: 'success'
                    });
                    return;
                        }
                        this.$message({
                            message: '删除失败',
                            type: 'warning'
                    });

                    })
            }
        },


    }
</script>
<style scoped lang="less">
    .home {
        /* background-color: #F7F8FC;; */
        /* padding: .2rem; */
        /* height: auto; */
        /* padding-left: 0rem; */
        width: 17.2rem;

    }

    .home-content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border-radius: 5px;
    }

    .mk1 {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        padding-left: .2rem;
        padding-bottom: .2rem;
        /* padding-top: .2rem; */
    }

    .mk1>div:nth-of-type(1) {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }




    .page-title {


        font-size: .2rem;
        font-weight: 500;
        color: #333333;
        position: relative;
        margin-left: .1rem;

    }

    .mk2 {
        display: flex;

        flex-direction: row;
        font-size: .14rem;
        font-weight: 400;
        color: #666666;
        margin-left: .2rem;
        margin-top: .2rem;
        padding-top: .2rem;
        background-color: #ffffff;
        ;
        justify-content: space-around;
    }

    .mk2>div {
        display: flex;
        flex-direction: column;
        width: 4.4rem;

    }

    .mk2>div:nth-of-type(1)>div {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: .1rem;
    }

    .name {
        display: flex;
        white-space: nowrap;
    }

    .mk2>div:nth-of-type(2)>div {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: .1rem;
    }

    .mk2>div:nth-of-type(3)>div {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: .1rem;
    }

    .mk2>div:nth-of-type(3)>div>span {
        white-space: nowrap;
    }

    .mk2>div:nth-of-type(3)>di {
        white-space: nowrap;
    }

    .select-xz {
        display: flex;
        width: 100%;
    }

    .time-xz {
        width: 4.12rem;
    }

    \deep\.el-input--suffix {
        width: 3.7rem;
    }

    .tables {
        margin-top: .2rem;
        margin-left: .2rem;
        /* padding: .2rem; */
        padding: 0.2rem;
    background: #fff;
        
    }

    .mk2title {
        display: flex;
        justify-content: space-between;
        color: #333333;
        font-size: .18rem;
        /* margin-top: .2rem; */
        font-weight: 500;
        height: .3rem;
        background-color: #fff;
        margin-left: 0rem;
        padding: .1rem .2rem .1rem .2rem;
    }

    .mk2title>div {
        display: flex;
        justify-content: center;
        align-items: center;
        /* width: .60rem; */
        height: .26rem;

        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        font-size: .14rem;
        color: #fff;
        cursor: pointer;
    }

    .pagination {
        display: flex;
        justify-content: flex-end;
        background-color: #fff;
        padding: .3rem 0;
    }

    .btns {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .btns>div:nth-of-type(1) {
        margin-right: .2rem;
        background-color: #EEB043;
        padding: .05rem;
    }

    .btns>div:nth-of-type(2) {
        margin-right: .2rem;
        background: #2CADD4;
        padding: .05rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/word/index.vue